import React from "react";
import "../../App.css";

export default function DP() {
  return (
    <div className="dp-container">
      <h1 className="dp">DISCIPLINE POLICY</h1>
      <div className="dp-info">
        <p>The school’s Discipline policy is designed to maintain a productive work environment for all students and to provide students with the opportunity to be responsible for themselves and for others.
        </p>
        <h2>School Rules (These apply at all times in school buildings and grounds.)</h2>
        <ul>
              <li>1.  School Rules (These apply at all times in school buildings and grounds.)</li>
              <li>2.	Don’t disrupt other students.</li>
              <li>3.	Don’t fight, bully, tease or torment other members of the school</li>
              <li>4.	Respect the other students and the property of the schools.</li>
              <li>5.	Participate in extra-curricular activities such as program, excursion and others.</li>
              <li>6.	Obey the school rules and procedures.</li>
        </ul>
        <h2>Classroom Rules</h2>
        <ul>
              <li>1.  Respect one another</li>
              <li>2.  Behave safely in the classroom</li>
              <li>3.	Speak one at a time</li>
              <li>4.	Be punctual to class</li>
              <li>5.	Be attentive, work cooperatively, and respect the opinion of other students</li>
        </ul>
        <h2>Rewards for Positive Behavior</h2>
        <p>A special privilege will be negotiated according to the child needs and preferences.  Points can be earned through appropriate behavior.</p>
      </div>
    </div>
  );
}
